<div class="editor-form-wrapper">
    @if (!isLoading()) {
        <ngx-monaco-diff-editor
            (onInit)="$event.revealFirstDiff()"
            [originalModel]="{ code: original(), language: 'json' }"
            [modifiedModel]="{ code: modified(), language: 'json' }"
            [options]="options"
        />
    }
</div>
